import React, { useEffect, useState } from "react";
import "./successStories.css";

import poster1 from "../Pages/images/success1.jpeg";
import poster2 from "../Pages/images/success2.jpeg";
import poster3 from "../Pages/images/success3.jpeg";
import poster4 from "../Pages/images/success/success1.jpg";
import poster5 from "../Pages/images/success/success2.jpg";
import poster6 from "../Pages/images/success/success3.jpg";

const stories = [
  { id: 1, title: "UK Visa Approved - Sai Adithya", image: poster1 },
  { id: 2, title: "UK Visa Approved - Makala Vamshidhar Reddy", image: poster2 },
  { id: 3, title: "UK Visa Approved - Ashwini Katagoni", image: poster3 },
  { id: 4, title: "UK Visa Approved - Rohith Reddy Janke", image: poster4 },
  { id: 5, title: "UK Visa Approved - Sathwika Yashwada", image: poster5 },
  { id: 6, title: "UK Visa Approved - Vinay Sherigudem", image: poster6 },
];

export default function SuccessStoriesPage() {
  const [open, setOpen] = useState(null);

  // ✅ close modal with ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(null);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div className="ssPage">
      <div className="ssHeader">
        <h1>Success Stories</h1>
        <p>Visa approvals & student journeys we are proud of.</p>
      </div>

      <div className="ssGrid">
        {stories.map((s) => (
          <div
            key={s.id}
            className="ssCard"
            onClick={() => setOpen(s)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setOpen(s)}
            aria-label={`Open ${s.title}`}
          >
            <img src={s.image} alt={s.title} className="ssPoster" />
          </div>
        ))}
      </div>

      {/* ✅ Modal Preview */}
      {open && (
        <div className="ssModal" onClick={() => setOpen(null)}>
          <div className="ssModalContent" onClick={(e) => e.stopPropagation()}>
            <button
              className="ssClose"
              onClick={() => setOpen(null)}
              aria-label="Close"
            >
              ✕
            </button>

            <img src={open.image} alt={open.title} className="ssModalImg" />
            <p className="ssModalTitle">{open.title}</p>
          </div>
        </div>
      )}
    </div>
  );
}
